import Philip_Vella_CV_2024 from "../assets/pdf/Principal Frontend Engineer - Philip Vella.pdf";

export const commonData = {
    resumePdf: Philip_Vella_CV_2024,
};
